var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgS3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    baseProfile: "full",
    width: 300,
    height: 350,
    xlmns: "http://www/w3/org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 0 350 L 300 0 V 350 H 0",
    fill: "#CEA830"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgS3);
export default __webpack_public_path__ + "static/media/s3.ec97932884e980c3f6f951ccf3e34797.svg";
export { ForwardRef as ReactComponent };